import {
  Flexbox, Form, Mask, QuickFilter,
} from '@/components'
import React from 'react'

function ClinicalCaresQuickFilter() {
  return (
    <QuickFilter
      initialValues={{
        'author.fullName_cont': '',
        'author.documentNumber_eq': '',
        'author.phoneNumber_eq': '',
      }}
      title="Filtrar atendimentos"
      renderForm={({ setFieldValue }) => (
        <>
          <Flexbox.Column className="col-3 mt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="tutorFullName">
                Nome do solicitante
              </Form.Label>
              <Form.ValidationField
                name="['author.fullName_cont']"
                className="input-sm"
                id="tutorFullName"
                autoComplete="none"
                placeholder="Fulano da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
          <Flexbox.Column className="col-3 mt-2">
            <Form.Group>
              <Form.Label
                className="label-sm pt-2"
                htmlFor="tutorDocumentNumber"
              >
                CPF/CNPJ do solicitante
              </Form.Label>
              <Form.ValidationField name="['author.documentNumber_eq']">
                {({ field }) => (
                  <Mask.CpfCnpj
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    className="input-sm"
                    placeholder="CPF/CNPJ do author"
                    id="tutorDocumentNumber"
                    onAccept={(value) => {
                      setFieldValue("['author.documentNumber_eq']", value)
                    }}
                  />
                )}
              </Form.ValidationField>
            </Form.Group>
          </Flexbox.Column>
          <Flexbox.Column className="col-3 mt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="tutorPhoneNumber">
                Telefone do solicitante
              </Form.Label>
              <Form.ValidationField name="['author.phoneNumber_eq']">
                {({ field }) => (
                  <Mask.Phone
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    className="input-sm"
                    placeholder="Número do telefone"
                    id="tutorPhoneNumber"
                    onAccept={(value) => {
                      setFieldValue("['author.phoneNumber_eq']", value)
                    }}
                  />
                )}
              </Form.ValidationField>
            </Form.Group>
          </Flexbox.Column>
        </>
      )}
    />
  )
}

export default ClinicalCaresQuickFilter
